import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_edit_order_units: { message: "idle" },
};

export const tenant_edit_order_units_Slice = createSlice({
 name: "tenant_edit_order_units",
 initialState,
 reducers: {
  success_tenant_edit_order_units: (state, action) => {
   state.tenant_edit_order_units = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_edit_order_units: (state, action) => {
   state.tenant_edit_order_units = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_edit_order_units: (state) => {
   state.tenant_edit_order_units = { status: app_consts.IDLE };
  },
  loading_tenant_edit_order_units: (state) => {
   state.tenant_edit_order_units = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_edit_order_units, fail_tenant_edit_order_units, reset_tenant_edit_order_units, loading_tenant_edit_order_units } = tenant_edit_order_units_Slice.actions;

export default tenant_edit_order_units_Slice.reducer;